'use client'

import { useEnvironmentVariables } from '@/hooks/UseEnvironmentVariables'
import { GTMHeaderScripts } from '@/components/organisms/TagManager/GTMHeaderScripts'

interface GtmHeaderLoaderProps {
    nonce: string | null
}

export const GtmHeaderLoader = ({ nonce }: GtmHeaderLoaderProps) => {
    const { env } = useEnvironmentVariables()
    const gtmKey = env?.GTM_KEY

    if (!gtmKey) {
        return null
    }

    return <GTMHeaderScripts gtmKey={gtmKey} nonce={nonce} />
}
